export default __webpack_public_path__ + "static/media/amex.f094ecf9.svg";